module.exports = __webpack_public_path__ + "static/img/iPadPro2017.76f53cc6.png";